import React from "react";
import { Box, Text, List, ListItem, Badge, Flex, Heading } from "@chakra-ui/react";

const Changelog = ({ changelogData }) => {
  // Utilisation des données fournies ou des données factices
  const data = changelogData || [
    { id: 1, date: "2024-12-08", action: "Comment added", user: "Alice Johnson" },
    { id: 2, date: "2024-12-07", action: "Category updated", user: "John Doe" },
    { id: 3, date: "2024-12-06", action: "Metadata updated", user: "Jane Smith" },
    { id: 4, date: "2024-12-05", action: "Title modified", user: "Emma Brown" },
    { id: 5, date: "2024-12-04", action: "Linked to fund", user: "Bob Brown" },
    { id: 6, date: "2024-12-03", action: "Changes approved", user: "Alice Johnson" },
    { id: 7, date: "2024-12-02", action: "Details added", user: "Jane Smith" },
    { id: 8, date: "2024-12-01", action: "Report created", user: "John Doe" },
  ];

  // Trier du plus récent au plus ancien
  const sortedData = [...data].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <Box>
      <List>
        {sortedData.map((entry) => (
          <ListItem key={entry.id} borderBottom={"1px solid"} borderColor={"grey.200"} py={2}>
            <Flex alignItems="center" justifyContent="space-between">
              <Box>
                <Heading fontSize="md" fontWeight={'500'}>{entry.action}</Heading>
                <Text fontSize="sm" color="gray.500">
                  {entry.user}
                </Text>
              </Box>
              <Badge>{new Date(entry.date).toLocaleDateString()}</Badge>
            </Flex>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Changelog;
